import { Auth } from '../../actions/action-types';

const tokenActions = new Set<string>([`${Auth.TOKEN_AVAILABLE}`]);
// This subscription will hook into new tokens available and
// dispatch events with the new token.  If included with auth-middleware
// then new tokens should automatically propagate to api calls.
const authSubscriptions: CMx.ChannelSubscription[] = [
  {
    observe: (message: MessageEvent) => {
      return message.data?.payload && tokenActions.has(message.data?.type);
    }
  }
];

export default authSubscriptions;
